export const ACCOUNT_DELETE_RESET = 'ACCOUNT_DELETE_RESET'
export const ACCOUNT_DELETE_SET_ERROR = 'ACCOUNT_DELETE_SET_ERROR'
export const ACCOUNT_DELETE_SET_DELETED = 'ACCOUNT_DELETE_SET_DELETED'
export const ACCOUNT_DELETE_TOGGLE_LOADING = 'ACCOUNT_DELETE_TOGGLE_LOADING'
